import React from "react";
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import URLParams from "../utils/url_params.js";

const Connector = (Component) => {

/**
 * Handle and update location.search, construct actual params for making request in API
 * Already includes hoc withRouter
 * @component
 * @category HOC
 * @param providedProps
 * @param {func(params)} providedProps.changeLocationSearch - Function for updating location.search
 * @param {object} providedProps.filterData - Params, converted from location search
 * 
*/
  const WithLocationSearchFilter = (Component) => {

    class WithLocationSearchFilter extends React.Component {

      constructor(props) {
        super(props);

        this.state = {
          filterData: URLParams.getValues()
        };

        this.changeLocationSearch = this.changeLocationSearch.bind(this);
        this.onHistoryChanged = this.onHistoryChanged.bind(this);
      }

      componentDidMount() {
        const { history } = this.props;
        this.unsubscribeFromHistory = history.listen(this.onHistoryChanged);
      }
    
      componentWillUnmount() {
        this.unsubscribeFromHistory();
      }

      changeLocationSearch(newParams, {replaceLocation = false} = {}) {
        const { history } = this.props;
    
        let filterData  = { ...this.state.filterData, ...newParams };
        let newSearch = URLParams.constructSearch(filterData);
        
        let location = { ...history.location };
        let currentSearch = location.search.substring(1);

        if(currentSearch !== newSearch) {
          location.search = newSearch;
          if(replaceLocation) {
            history.replace(location);
          }
          else {
            history.push(location);
          }
          
        }
        
      }
    
      onHistoryChanged() {
        let newFilterData = URLParams.getValues();
        this.setState({
          filterData: newFilterData
        })
      }

      render() {
        const { filterData } = this.state;
        return <Component { ...this.props } 
                          changeLocationSearch = { this.changeLocationSearch }
                          filterData = { filterData } />
      }
    }

    return WithLocationSearchFilter;
  };

  return compose(withRouter, WithLocationSearchFilter)(Component);
}

export default Connector;
